import {Component, inject, OnInit} from '@angular/core';
import {CmsApiService} from '../../core/cms-api.service';
import {CommonsService} from '../../core/commons.service';
import {LoginService} from '../../core/login.service';
import {PrimusRouterService} from '../../core/primus-router.service';
import {FeatureFlagsService} from "../../core/feature-flags.service";
import {PrimusBackendInstanceService, PrimusInstanceDetails} from "../../core/primus-backend-instance.service";
import {environment} from "../../../environments/environment";

export class UserManual {
  manuals: UserManualItem[];
}

export class UserManualItem {
  href: string;
  title: string;
}

@Component({
    selector: 'app-about-primus',
    templateUrl: './about-primus.component.html',
    styleUrls: ['./about-primus.component.scss'],
    standalone: false
})
export class AboutPrimusComponent implements OnInit {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly commons: CommonsService = inject(CommonsService);
  private readonly featureFlagsService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly loginService: LoginService = inject(LoginService);
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);

  museum: PrimusInstanceDetails;
  parent = {
    adminType: 'about',
    hasSubMenus: false,
    currentState: ''
  };

  edition = {
    title: ''
  };
  version: string;
  frontendVersion: string = environment.version;
  userManual: UserManual;

  ngOnInit() {
    this.setEditionAndVersion((edition: any, version: string) => {
      this.edition = edition;
      this.version = version;
    });

    this.userManual = {
      manuals: [{
        href: this.cms.getApiUrl('translation/manual/', true),
        title: 'TRANS__ABOUT_PRIMUS__USER_MANUAL'
      }],
    }
    this.parent = {
      adminType: 'about',
      hasSubMenus: false,
      currentState: this.primusRouter.currentState()
    };

    this.museum = PrimusBackendInstanceService.getInstanceDetails();

  }

  private setEditionAndVersion(fn: any) {
    this.loginService.currentUser.subscribe(user => {
      if (user) {
        const edition = this.commons.setEditionTitle(user);
        const version = user['version'];
        fn(edition, version);
      }
    });
  }

  readonly useNewLayout = this.featureFlagsService.getFeatureFlags()?.experimental?.useNewMainMenu;
}
